import React from 'react';
import { bundles } from '../data/mockData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Bundles = () => {
  return (
    <section className="py-16 bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center gap-3 mb-8">
          <SafeIcon icon={FiIcons.FiPackage} className="text-2xl text-indigo-600" />
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Pre-configured Bundles</h2>
            <p className="text-slate-600 text-sm">Optimized loadouts for specific workflows. Save up to 15%.</p>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {bundles.map(bundle => (
            <div key={bundle.id} className="flex flex-col sm:flex-row border border-slate-200 rounded-lg overflow-hidden hover:border-indigo-300 transition-colors">
              <div className="sm:w-2/5 h-48 sm:h-auto bg-slate-100">
                <picture>
                  <source type="image/avif" srcSet={`${bundle.image}&fm=avif`} />
                  <source type="image/webp" srcSet={`${bundle.image}&fm=webp`} />
                  <img 
                    src={bundle.image} 
                    alt={`Curated collection for ${bundle.name}`} 
                    className="w-full h-full object-cover"
                    loading="lazy"
                    width="320"
                    height="240"
                  />
                </picture>
              </div>
              <div className="p-6 sm:w-3/5 flex flex-col justify-between bg-white">
                <div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{bundle.name}</h3>
                  <ul className="text-sm text-slate-600 mb-4 space-y-1">
                    {bundle.items.map((item, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <SafeIcon icon={FiIcons.FiCheck} className="text-green-500 text-xs" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex items-end justify-between mt-4">
                  <div>
                    <div className="text-xs text-slate-400 line-through font-mono">${bundle.originalPrice}</div>
                    <div className="text-xl font-bold text-slate-900 font-mono">${bundle.price}</div>
                  </div>
                  <button className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-800 text-sm font-medium rounded transition-colors">
                    View Bundle
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Bundles;